import { render, staticRenderFns } from "./ComponentImageBrowser.vue?vue&type=template&id=4dc0e3fc&scoped=true&"
import script from "./ComponentImageBrowser.vue?vue&type=script&lang=js&"
export * from "./ComponentImageBrowser.vue?vue&type=script&lang=js&"
import style0 from "./ComponentImageBrowser.vue?vue&type=style&index=0&id=4dc0e3fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc0e3fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCarousel,VCarouselItem,VImg})
